<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created: function () {
    if (window.localStorage.getItem('store') && this.$route.name != 'Login') {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(window.localStorage.getItem('store'))))
      //this.Common.connentMqtt(true)
    }
  },
  mounted: function () {
    window.addEventListener('beforeunload', () => {
      window.localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style>
#app {
  font-family:"Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(255, 208, 75);
  width:100%;
  height:100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue